<nz-form-item>
    
    <nz-form-label [nzSpan]="4" nzFor="tyreSize">Tyre Size</nz-form-label>
    <nz-form-control [nzSpan]="10" [appValidationBorder]="incidentTyre.size">
        <nz-select nzShowSearch nzMode="default" nzPlaceHolder="Select Tyre Size"
            id="tyreSize" name="tyreSize" [(ngModel)]="incidentTyre.size">
            @for (item of sharedDataService.tyreSizes; track $index) {
                <nz-option [nzValue]="item.gencode" [nzLabel]="item.size"></nz-option>
            }
            <nz-option [nzValue]="'123456789'" [nzLabel]="'Other: See Breakdown Description'"></nz-option>
        </nz-select>
    </nz-form-control>
    <!-- @if (incidentTyre.tyreNumber === 0) { -->
        <nz-form-label [nzSpan]="4" nzFor="tyreQty">Qty</nz-form-label>
        <nz-form-control [nzSpan]="6">
            <nz-input-number id="tyreQty" name="tyreQty" [(ngModel)]="incidentTyre.qty" nzMin="1" nzMax="100" />
        </nz-form-control>
    <!-- }
    @else { -->
        <!-- <nz-form-label [nzSpan]="4" nzFor="tyrePos">Position</nz-form-label>
        <nz-form-control [nzSpan]="6">
            <nz-input-number id="tyrePos" name="tyrePos" [(ngModel)]="incidentTyre.tyreNumber" [nzMin]="getTyreLocationRange().min" [nzMax]="getTyreLocationRange().max"/>
        </nz-form-control> -->
    <!-- } -->
    
</nz-form-item> 
